import React, { useMemo } from "react";
import { notification, Space } from "antd";
import "./index.scss";

const Context = React.createContext({ name: "Default" });

const openNotification = (
  type: "success" | "error" | "info" | "warning",
  message: string,
  description: string,
  duration?: number,
  placement?: "topRight" | "topLeft" | "bottomRight" | "bottomLeft"
) => {
  notification[type]({
    duration: duration ?? 4.5,
    message,
    description,
    className: "custom-notification",
    placement: placement ?? "topRight",
  });
};

const Notification: React.FC = () => {
  const [api, contextHolder] = notification.useNotification();

  const contextValue = useMemo(() => ({ name: "Ant Design" }), []);

  return (
    <Context.Provider value={contextValue}>
      {contextHolder}
      <Space style={{ padding: "10px", display: "block" }} />
    </Context.Provider>
  );
};

export default Notification;

export { openNotification };
